import * as React from 'react';

export type CourseDataProviderContext = {
  courseId?: string;
  courseSlug?: string;
  courseName?: string;
};

type PropsFromCaller = {
  children: React.ReactNode;
} & CourseDataProviderContext;

const CourseDataContext = React.createContext<CourseDataProviderContext>({});

/**
 * The spirit of this component is to grab the course data from course home (aka Course.tsx) and provide it to child components
 * to be consumed via a hook. Since we already do the data fetching in Course.tsx, we just provide the values we need
 * and don't need to do any additional fetching here.
 */
export const CourseDataProvider = ({ children, courseId, courseSlug, courseName }: PropsFromCaller) => {
  return (
    <CourseDataContext.Provider value={{ courseId, courseSlug, courseName }}>{children}</CourseDataContext.Provider>
  );
};

export const useCourseDataProvider = () => {
  // We want this to hook to be truly optional, so we do not throw an error if this is used outside of a CourseDataProvider
  const context = React.useContext(CourseDataContext);
  return context;
};

export default CourseDataProvider;
